import React from 'react';
import { Breadcrumbs, Link as MuiLink, Typography } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Link as RouterLink } from 'react-router-dom';
import { useTrail } from './TrailProvider';


export default function BreadcrumbTrail() {
  const trail = useTrail();

  if (!trail?.length) return null;

  return (
    <Breadcrumbs
      separator={<ArrowRightIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{
        mb: 1,
        '& .MuiBreadcrumbs-ol': { alignItems: 'center' },
      }}
    >
      {trail.map((c, i) =>
        i === trail.length - 1 ? (
          <Typography
            key={`${c.href}-${i}`}
            sx={{
              fontFamily: 'Source Sans Pro',
              fontSize: '0.875rem',
              color: 'black',
              whiteSpace: 'nowrap',
            }}
            aria-current="page"
          >
            {c.label}
          </Typography>
        ) : (
          <MuiLink
            key={`${c.href}-${i}`}
            component={RouterLink}
            to={c.href}
            state={{ trail: trail.slice(0, i + 1) }}
            sx={{
              fontFamily: 'Source Sans Pro',
              fontSize: '0.875rem',
              color: '#5236AB',
              textDecoration: 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            {c.label}
          </MuiLink>
        )
      )}
    </Breadcrumbs>
  );
}
